export class UpdateNeededFilter {
  public IncludeInactive?: boolean;
}

export default UpdateNeededFilter;
